import React from "react";
import RichText from './RichText'
export default function StateContainer(props) {
  return (
    <div className="city-state-container">
    <div className="container-fluid">
    <div className="title-section">
        <h1>{props?.StateContainer?.content?.Header[0]?.headline}</h1>
        {/* <p>The State of Illinois has legal minimum requirements for car insurance. Springfield drivers need both liability coverage and uninsured/underinsured motorist coverage.</p> */}
      </div>
      {/* {props?.StateContainer?.content?.Media_Object_Group[0]?.Description?.content?.map( */}
        {/* (data) => { */}
          {/* return ( */}
            <>
              {/* <p>{data?.content[0]?.text}</p> */}
              <div className="custom-list">
                <div className="icons_legal">
                  {/* <img src={data?.content[0]?.attrs?.src} /> */}
                </div>
                <div className="">
                  {/* <p>
                    <b> {data?.content[1]?.text}</b> {data?.content[2]?.text}
                  </p> */}
                  <RichText Description={props?.StateContainer?.content?.Media_Object_Group[0].Description}></RichText>
                </div>
              </div>
            </>
          {/* ); */}
        {/* } */}
      {/* )} */}
    </div>
    </div>
  );
}
